import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { Observable } from 'rxjs';

@Injectable()
export class ExerciseService {
  private $api: string = '';

  constructor(private $ajax: AjaxService) {
    this.$api = this.$ajax.getAPIDomain();
  }

  /**
   * 운동 목록 반환
   */
  exChart(bmiNum: number): Observable<any> {
    return this.$ajax.httpRequest(
      'GET',
      this.$api + `ex-chart-list/${bmiNum}`,
    );
  }

  /**
   * 아동 초검/재검 정보 반환
   */
  exChartTestData(bmiNum: number): Observable<any> {
    return this.$ajax.httpRequest(
      'GET',
      this.$api + `ex-chart-test-data/${bmiNum}`,
    );
  }

  /**
   * 선택된 아동의 운동에 대한 기록 가져옴
   */
  exChartDetail(bmiNum: number, eNum: number): Observable<any> {
    return this.$ajax.httpRequest(
      'GET',
      this.$api + `detail-chart-data/${bmiNum}/${eNum}`,
    );
  }

  /**
   * 운동 정보 반환 (뇌 정보 포함)
   */
  exChartDetailInfo(eNum: number): Observable<any> {
    return this.$ajax.httpRequest(
      'GET',
      this.$api + `detail-info/${eNum}`,
    );
  }

  /**
   * 안구/검사 운동 정보 반환 (뇌 정보 포함)
   */
  exChartEyeTestInfo(ecNum: number): Observable<any> {
    return this.$ajax.httpRequest(
      'GET',
      this.$api + `eye-test-info/${ecNum}`,
    );
  }
}
